// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__420Zj","checkboxCol":"Table_checkboxCol__27V-u","emailCol":"Table_emailCol__Eo3iv","actionCol":"Table_actionCol__2jc19"};